import {MinusCircleOutlined} from '@ant-design/icons';
import {Button, Form, Input, Select} from 'antd';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {createTable, getUniqDeviceParams, setShowCreateModal} from "../../redux-store/dynamicTable";
import {dynamicTableList, installationSelectData, uniqueDeviceTypes} from "../../redux-store/selectors";
import {columnAlignmentOptions, columnTypeOptions, pipeArgOptions} from "./TableConfigStaticSelectOptions";
import ErrorIcon from "../../images/errorIcon.png";
import {REQUIRED_FIELD} from "../../constants/Messages";

const {Option} = Select

function TableConfigCreateForm() {

    const {selected} = useSelector(installationSelectData)
    const {uniqueReadableParams, uniqueCommandProducers} = useSelector(uniqueDeviceTypes)
    const tableList = useSelector(dynamicTableList)
    const [form] = Form.useForm();

    const dispatch = useDispatch()


    const onFinish = async (values) => {
        values.columns = values.columns?.map((column) => {
            if (column.type === "DATA") {
                column.methodName = null
                column.arguments = null
            } else if (column.type === "COMMAND") {
                column.parameterName = null
                column.pipe = null;
                column.pipeArg = null;
                column.alignment = "CENTER";
                if (column.arguments)
                    column.arguments = JSON.parse("[" + column.arguments + "]");
                else
                    column.arguments = [];
            }
            return column
        })
        dispatch(createTable({installationId: selected.value, data: values}))
    };

    const findHighestDisplayOrder = () => {
        let highest = 0;

        tableList.forEach((table) => {
            if (table.displayOrder > highest) {
                highest = table.displayOrder
            }
        })
        form.setFieldValue("displayOrder", highest + 1)
    }

    useEffect(() => {
        dispatch(getUniqDeviceParams())
        findHighestDisplayOrder()
    }, [])

    const handleCloseModal = (e) => {
        e.preventDefault()
        dispatch(setShowCreateModal(false))
    }

    return (
        <Form form={form} name="dynamic_form_nest_item" onFinish={onFinish} autoComplete="off"
              className={"flux-tables-antd"}>
            <Form.Item
                name={"name"}
            >
                <Input placeholder="Name" className={"form-control"}/>
            </Form.Item>
            <Form.Item
                name={"description"}
            >
                <Input placeholder="Description"/>
            </Form.Item>
            <Form.Item
                name={"displayOrder"}
            >
                <Input placeholder="Display order"/>
            </Form.Item>
            <Form.List name="columns">
                {(fields, {add, remove}) => (
                    <>
                        {fields.map(({key, name, ...restField}) => (<>
                            <Form.Item
                                {...restField}
                                name={[name, 'type']}
                                rules={[
                                    {
                                        required: true,
                                        message: <span className="loggin-error"><img
                                            src={ErrorIcon}/> {REQUIRED_FIELD}</span>,
                                    },
                                ]}
                            >
                                <Select
                                    placeholder={"Type"}
                                    className={"form-select"}
                                    getPopupContainer={node => node.parentNode}
                                >
                                    {columnTypeOptions.map((item, index) => {
                                        return (<Option key={index} value={item.value}>{item.label}</Option>)
                                    })}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                noStyle
                                shouldUpdate={true}
                            >
                                {({getFieldValue}) => {
                                    if (!getFieldValue("columns")[name]?.type) {
                                        return;
                                    }
                                    return getFieldValue("columns")[name]?.type === 'DATA' ? (<Form.Item
                                        {...restField}
                                        name={[name, 'parameterName']}
                                        rules={[
                                            {
                                                required: true,
                                                message: <span className="loggin-error"><img
                                                    src={ErrorIcon}/> {REQUIRED_FIELD}</span>,
                                            },
                                        ]}
                                    >
                                        <Select
                                            placeholder={"Parameter Name"}
                                            className={"form-select"}
                                            showSearch
                                            getPopupContainer={node => node.parentNode}
                                        >
                                            {uniqueReadableParams.map((item, index) => {
                                                return (<Option key={index} value={item}>{item}</Option>)
                                            })}
                                        </Select>
                                    </Form.Item>) : (<>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'methodName']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: <span className="loggin-error"><img
                                                            src={ErrorIcon}/> {REQUIRED_FIELD}</span>,
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    placeholder={"Method Name"}
                                                    className={"form-select"}
                                                    showSearch
                                                    getPopupContainer={node => node.parentNode}
                                                >
                                                    {uniqueCommandProducers.map((item, index) => {
                                                        return (<Option key={index} value={item}>{item}</Option>)
                                                    })}
                                                </Select>
                                            </Form.Item>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'arguments']}
                                            >
                                                <Input placeholder="Arguments"/>
                                            </Form.Item>
                                        </>

                                    )
                                }}
                            </Form.Item>
                            <Form.Item
                                {...restField}
                                name={[name, 'title']}
                            >
                                <Input placeholder="Title"/>
                            </Form.Item>
                            <Form.Item
                                {...restField}
                                name={[name, 'description']}
                            >
                                <Input placeholder="Description"/>
                            </Form.Item>
                            <Form.Item
                                noStyle
                                shouldUpdate={true}
                            >
                                {({getFieldValue}) => {
                                    if (!getFieldValue("columns")[name]?.type) {
                                        return;
                                    }
                                    return getFieldValue("columns")[name]?.type === 'DATA' && (<>
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'pipe']}
                                        >
                                            <Select
                                                placeholder={"pipe"}
                                                className={"form-select"}
                                                getPopupContainer={node => node.parentNode}
                                            >
                                                {pipeArgOptions.map((item, index) => {
                                                    return (
                                                        <Option key={index} value={item.value}>{item.label}</Option>)
                                                })}
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'pipeArg']}
                                        >
                                            <Input placeholder="PipeArg"/>
                                        </Form.Item>
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'alignment']}
                                        >
                                            <Select
                                                placeholder={"Alignment"}
                                                className={"form-select"}
                                                getPopupContainer={node => node.parentNode}
                                            >
                                                {columnAlignmentOptions.map((item, index) => {
                                                    return (
                                                        <Option key={index} value={item.value}>{item.label}</Option>)
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </>)
                                }}
                            </Form.Item>
                            <Form.Item className={"text-center btn-minus"}>
                                <MinusCircleOutlined onClick={() => remove(name)}/>
                            </Form.Item>
                        </>))}
                        <Form.Item>
                            <Button type="dashed" onClick={() => add()} block>
                                Dodaj kolonu
                            </Button>
                        </Form.Item>
                    </>)}
            </Form.List>
            <Form.Item>
                <div className={"ant-form-tables-flux"}>
                    <button className={"btn btn-modal-cancel"} onClick={handleCloseModal}>
                        Odustani
                    </button>
                    <button className={"btn btn-modal-confirm"}>Sačuvaj</button>
                </div>
            </Form.Item>
        </Form>
    )
};

export default TableConfigCreateForm;